import { gql } from "graphql-request";

// the Filminfo queries for the program on the movie pages: the dates with shows, and the shows on a date (or all dates)

export const SHOWDATES_BY_ID_QUERY = gql`
query ($locations: [String], $movieId: String, $firmId: Int) {
	showQuery {
		getShowDates (locations: $locations, movieId: $movieId, firmId: $firmId) {
			__typename
			date
		}
	}
}`;

export const SHOWDATES_BY_TITLE_QUERY = gql`
query ($locations: [String], $movieTitle: String, $firmId: Int) {
	showQuery {
		getShowDates (locations: $locations, movieTitle: $movieTitle, firmId: $firmId) {
			__typename
			date
		}
	}
}`;

export const SHOWSFORDATE_BY_ID_QUERY = gql`query ($locations: [String], $movieId: String, $date: String, $firmId: Int) {
	showQuery{
		getShows(locations: $locations, movieId: $movieId, date: $date, removePastShows: true, firmId: $firmId) {
			__typename
            id,
            theaterId,
			movieMainVersionId
			movieVersionId
			movieTitle
			showStart
			ticketSaleUrl
			screenName
			theaterName
			showType
			firmName
			isKinoklubb
			versionTags {
				tag
			}
		}
	}
}`;

export const SHOWSFORDATE_BY_TITLE_QUERY = gql`query ($locations: [String], $movieTitle: String, $date: String, $firmId: Int) {
	showQuery{
		getShows(locations: $locations, movieTitle: $movieTitle, date: $date, removePastShows: true, firmId: $firmId) {
			__typename
            id,
            theaterId,
			movieMainVersionId
			movieVersionId
			movieTitle
			showStart
			ticketSaleUrl
			screenName
			theaterName
			showType
			firmName
			isKinoklubb
			versionTags {
				tag
			}
		}
	}
}`;